<template id="client-delete">
  <div>
    <h1>Esborrar client</h1>
    <hr>
    <b-form v-on:submit.prevent="deleteClient">
        <div>
            <b-card
                v-bind:title= "cliente.nombre"
                style="max-width: 20rem;"
                class="mb-2"
            >
              <b-card-text>
                <br>
                <p>Nif: {{ cliente.nif }}</p>
                <p>Adreça: {{ cliente.direccion }} </p>
                <p>Població: {{ cliente.poblacion }}</p>
                <p>Provincia: {{ cliente.provincia }}</p>
                <p>CP: {{ cliente.cp }} </p>
              </b-card-text>
            </b-card>
        </div>
        <b-form-input :hidden="true" type="text" v-model="cliente.identifier"></b-form-input>
        <b-button type="submit" class="btn btn-danger">Delete</b-button>
        <a class="btn btn-default"><router-link :to="{ name: 'Clients'}">Cancel</router-link></a>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  props: {
    cliente: {
      identifier: null,
      nombre: null,
      nif: null,
      cp: null,
      poblacion: null,
      provincia: null,
      direccion: null
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    deleteClient () {
      (async () => {
        await DataAccess.deleteData('/api/clients', this.cliente.identifier)
          .then(response => {
            this.$router.push({ name: 'Clients' })
          })
          .catch(error => {
            console.log('ERROR: ', error)
          })
      })()
    }
  }

}
</script>
